<template>
  <footer>
    <hr/>
  </footer>
</template>

<script>
export default {
  name: 'Foot'
}
</script>
